import { useState } from 'react'
import { cx } from '@dorixona/ui'

export interface NewsPhotoProps {
  src: string
  className?: string
  /** Фото первого экрана грузим сразу, в ленте — по мере прокрутки. */
  loading?: 'eager' | 'lazy'
}

/**
 * Фото новости, всегда 16:9: рамка держит место, пока файл идёт, и экран не
 * прыгает. Фото нет или файл не открылся — остаётся спокойная подложка, а не
 * значок «битая картинка». Фото иллюстрирует заголовок рядом, поэтому для
 * читалки оно декоративное.
 */
export function NewsPhoto({ src, className, loading = 'lazy' }: NewsPhotoProps) {
  const [broken, setBroken] = useState('')
  return (
    <span className={cx('news-photo', className)}>
      {src && broken !== src ? (
        <img
          src={src}
          alt=""
          loading={loading}
          decoding="async"
          onError={() => {
            setBroken(src)
          }}
        />
      ) : null}
    </span>
  )
}
